import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import RegistrationForm from '../components/RegistrationForm';
import { Container, Row, Col } from 'react-bootstrap';
import { getEvent } from '../config/events';

const RegisterPage = () => {
  const { eventId } = useParams();
  const event = getEvent(eventId || 'youth-bootcamp');
  
  if (!event) {
    return <div>Event not found</div>;
  }
  return (
    <>
      <Header />
      <div className="pt-5 mt-5">
        <Container className="mb-5">
          <Row className="justify-content-center">
            <Col md={8}>
              <RegistrationForm event={event} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default RegisterPage;